import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARFISH_SAP3_RECOMMENDED_ANGLES = createFcmDetails('starfish_sap3_recommended_angles', {
	owner: 'starfish',
	context: 'starfish recommended angles in SAP flow',
	description: 'Controls display of recommended angles feature in SAP flow.',
	import: false,
});
